// Used to log boolean flags.

import {
    log as logReceivedFlag,
    AvroOptional,
} from '@indeed/signals-schema/com/indeed/signals/schema/profile/MobRcvFlag';

const getLogReceivedFlag = (mobtk: string) => (type: string) => {
    logReceivedFlag({
        mobtk,
        parentEventType: 'mobviewjob',
        flag: AvroOptional.string(type),
        ts: AvroOptional.long(new Date().getTime()),
    });
};

export default getLogReceivedFlag;
